import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { CatalogServiceProductData } from 'src/services/catalog/types';
import { transformProductModelToProduct } from 'src/utils/catalogProductToProduct';
import type { PartnerProduct } from './types';

/**
 * One of a partner's products is one card's props. The mapping from catalog product
 * to OOUX product is shared with the product carousel, so both agree on what a
 * catalog product means; only the card-level presentation is decided here.
 */
export const transformProductModelToPartnerProduct = (
  product: CatalogServiceProductData,
  {
    currency,
    priority,
    promoteAsSale,
  }: { currency: CurrencyCode; priority: boolean; promoteAsSale: boolean },
): PartnerProduct => ({
  isNew: product.isNew,
  priority,
  product: transformProductModelToProduct(product, { currency }),
  /* From the site-wide Contentstack switch, not `product.onSale`. No discount in the
     catalogue distinguishes a sale from an offer, so presenting one as either is a
     decision about the whole site rather than about this block or this product. */
  promoteAsSale,
});
